// extracted by css-extract-rspack-plugin
export default {"header":"oA1W7cGIEQc7l0k8__header___","paywallBanner":"VzstmvHKiKY95qW9__paywallBanner___"};